import { render } from "./coupon-item.vue?vue&type=template&id=d4c02f2a&scoped=true"
import script from "./coupon-item.vue?vue&type=script&lang=js"
export * from "./coupon-item.vue?vue&type=script&lang=js"

import "./coupon-item.vue?vue&type=style&index=0&id=d4c02f2a&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4c02f2a"]])

export default __exports__